<template>
  <div>
    <base-title-bar-scroll-page ref="container" :show-title-bar="!isApp" title="视频播放">
      <div v-if="loading"></div>
      <div v-else-if="courseDetail">
        <video :poster="courseDetail.coverUrl || ''" :src="courseDetail.videoUrl || ''" autoplay controls
               style="width: 100%;max-height: 93vh"></video>
        <div class="player-body">
          <div class="player-title">{{ courseDetail.title || '课程' }}</div>
          <div class="player-sub">课程编号：{{ courseDetail.courseNum || '-' }}</div>

          <div v-if="hasAnyInfo" class="player-sections">
            <template v-if="courseDetail.brief">
              <van-divider/>
              <div class="player-section-title">摘要：</div>
              <span class="player-text" v-html="getCourseText(courseDetail.brief)"></span>
            </template>

            <template v-if="courseDetail.text">
              <van-divider/>
              <div class="player-section-title">动作指导：</div>
              <span class="player-text" v-html="getCourseText(courseDetail.text)"></span>
            </template>

            <template v-if="courseDetail.trainingMethods">
              <van-divider/>
              <div class="player-section-title">训练说明：</div>
              <span class="player-text" v-html="getCourseText(courseDetail.trainingMethods)"></span>
            </template>

            <template v-if="courseDetail.attention">
              <van-divider/>
              <div class="player-section-title">注意事项：</div>
              <span class="player-text" v-html="getCourseText(courseDetail.attention)"></span>
            </template>
          </div>

          <div v-if="hasCatalog" class="catalog">
            <div class="catalog__title">课程目录</div>
            <div class="catalog__list">
              <div class="catalog__item" :class="{ 'is-active': v.videoId === currentVideoId }" v-for="v in courseDetail.courseVideoList" :key="v.videoId" @click="selectVideo(v)">
                <div class="catalog__item-name">{{ v.title }}</div>
                <div class="catalog__item-meta">时长：{{ formatDuration(v.duration) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="padding: 16px; color: #888">暂无课程数据</div>
    </base-title-bar-scroll-page>
  </div>
</template>
<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import PlanDao from '@/h5/doucan/network/PlanDao'
import TicaoDao from '@/h5/doucan/network/Ticao.js'

/**
 * test ：
 * http://192.168.0.119:8094/doucan/#/CourseDetailVideoPlayPage?courseId=e5ec334d-1023-4b52-9a0d-21432fc975cb&isApp=true&userId=1
 */
export default {
  name: 'CourseDetailVideoPlayPage',
  components: { BaseTitleBarScrollPage },
  data () {
    return {
      loading: true,
      isApp: false,
      userId: null,
      courseId: null,
      courseDetail: null,
      videoId: null,
      currentVideoId: null
    }
  },
  mounted () {
    this.courseId = this.$route.query.courseId
    this.videoId = this.$route.query.videoId
    this.userId = this.$route.query.userId || ''
    this.isApp = this.$route.query.isApp === '1' || this.$route.query.isApp === 'true'
    console.log('userId', this.userId)
    console.log('isApp', this.isApp)

    this.loadCourseDetail()
    this.hideLoading()
  },
  methods: {
    hideLoading () {
      this.$refs.container.stopLoading()
    },
    async loadCourseDetail () {
      try {
        // 优先使用小程序课程详情接口
        let detail = await TicaoDao.findOne(this.courseId)
        if (!detail) {
          // 兜底旧接口
          detail = await PlanDao.loadCourseForApp(this.courseId)
        }
        let result = detail || null
        // 优先定位到指定分集
        if (result && this.videoId && Array.isArray(result.courseVideoList)) {
          const picked = result.courseVideoList.find(v => String(v.videoId) === String(this.videoId))
          if (picked) {
            result = { ...result, title: picked.title || result.title, videoUrl: picked.videoUrl || result.videoUrl, coverUrl: picked.coverUrl || result.coverUrl }
            this.currentVideoId = picked.videoId
          }
        }
        this.courseDetail = result
        console.log('courseDetail', this.courseDetail)
        this.loading = false
      } catch (err) {
        console.error('加载课程失败', err)
        this.courseDetail = null
        this.loading = false
      }
    },
    getCourseText (text) {
      if (!text) {
        return ''
      }
      const raw = String(text)
      // 将文本按 '/n' 分割成段落数组
      let paragraphs = raw.split('/n')
      // 过滤空行
      paragraphs = paragraphs.filter(p => p && p.trim() !== '')
      // 遍历每一段，加前缀圆点
      const numberedParagraphs = paragraphs.map(paragraph => `· ${paragraph}`)
      // 连接为带换行的 HTML
      return numberedParagraphs.length ? ('<br>' + numberedParagraphs.join('<br>')) : ''
    },
    getCourseText (text) {
      if (!text) {
        return ''
      }
      const raw = String(text)
      let paragraphs = raw.split('/n')
      paragraphs = paragraphs.filter(p => p && p.trim() !== '')
      const numberedParagraphs = paragraphs.map(paragraph => `· ${paragraph}`)
      return numberedParagraphs.length ? ('<br>' + numberedParagraphs.join('<br>')) : ''
    },
    formatDuration (seconds) {
      const s = Number(seconds || 0)
      const mm = Math.floor(s / 60)
      const ss = s % 60
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return `${pad(mm)}:${pad(ss)}`
    },
    selectVideo (v) {
      if (!v) return
      this.currentVideoId = v.videoId
      this.courseDetail = { ...this.courseDetail, title: v.title || this.courseDetail.title, videoUrl: v.videoUrl || this.courseDetail.videoUrl, coverUrl: v.coverUrl || this.courseDetail.coverUrl }
    }
  },
  watch: {},
  computed: {}
}
</script>
<style scoped>
.player-body { padding: 0 16px 16px; }
.player-title { font-size: 18px; font-weight: 700; margin-top: 8px; }
.player-sub { font-size: 12px; color: #656565; }
.player-section-title { font-size: 14px; font-weight: 700; }
.player-text { display: inline-block; text-align: justify; font-size: 16px; }
.catalog { margin: 12px 0; }
.catalog__title { font-size: 14px; font-weight: 700; margin-bottom: 6px; }
.catalog__list { display: grid; grid-template-columns: 1fr; gap: 8px; }
.catalog__item { background: #f8f8f8; border-radius: 8px; padding: 8px 10px; }
.catalog__item.is-active { border: 1px solid #07c160; background: #f0fff7; }
.catalog__item-name { font-size: 14px; font-weight: 600; }
.catalog__item-meta { font-size: 12px; color: #888; margin-top: 2px; }
</style>
